<template>
  <div class="card">
    <div class="card-body">
      <!-- Nav tabs -->
      <div>
        <div class="d-flex justify-content-end mb-3">
          <i class="fas fa-sliders-h size" @click="showFilters"></i>
        </div>
        <div class="row" :class="{'d-none' : filtersT}">
          <div class="col-lg-3 mb-2">
            <multiselect
              v-model="filters.competition"
              label="name"
              track-by="value"
              :options="filters.competitionOptions"
              :searchable="false"
              :close-on-select="false"
              :show-labels="true"
              :allow-empty="true"
              selectLabel="Սեղմեք enter ընտրելու համար"
              deselectLabel="Սեղմեք հեռացնելու համար"
              selectedLabel="Ընտրված է"
              placeholder="Տիպ"
            />
          </div>
          <div class="col-lg-3 mb-2">
            <multiselect
              v-model="filters.category"
              label="name"
              track-by="value"
              @input="handleMyFilters"
              :options="filters.categoryOptions"
              :searchable="false"
              :close-on-select="false"
              :show-labels="true"
              :allow-empty="true"
              selectLabel="Սեղմեք ընտրելու համար"
              deselectLabel="Սեղմեք հեռացնելու համար"
              selectedLabel="Ընտրված է"
              placeholder="Ընտրել"
            />
          </div>
          <div class="col-lg-3 mb-2 w-100">
            <multiselect
              v-model="filters.status"
              label="name"
              track-by="value"
              :options="filters.statusOptions"
              :searchable="false"
              :close-on-select="false"
              :show-labels="true"
              :allow-empty="true"
              selectLabel="Սեղմեք ընտրելու համար"
              deselectLabel="Սեղմեք հեռացնելու համար"
              selectedLabel="Ընտրված է"
              placeholder="Կարգավիճակ"
            />
          </div>
          <div class="col-lg-3 mb-2">
            <multiselect
              v-model="filters.type"
              :options="filters.typeOptions"
              label="name"
              track-by="value"
              :searchable="false"
              :close-on-select="false"
              :show-labels="true"
              :allow-empty="true"
              selectLabel="Սեղմեք ընտրելու համար"
              deselectLabel="Սեղմեք հեռացնելու համար"
              selectedLabel="Ընտրված է"
              placeholder="Տեսակ"
            />
          </div>
          <div class="col-lg-3 mb-2">
            <multiselect
              v-if="filters.type != 'ՀՀ֊ից դուրս մրցույթներ'"
              v-model="filters.region"
              track-by="name"
              label="name"
              :options="filters.regionOptions"
              :searchable="false"
              :close-on-select="false"
              :show-labels="true"
              :allow-empty="true"
              selectLabel="Սեղմեք ընտրելու համար"
              deselectLabel="Սեղմեք հեռացնելու համար"
              selectedLabel="Ընտրված է"
              :multiple="true"
              placeholder="Տարածաշրջան"
            />
          </div>
          <div class="col-lg-3 mb-2">
            <multiselect
              v-model="filters.guaranteed"
              :options="filters.guaranteedOptions"
              label="name"
              track-by="value"
              :searchable="false"
              :close-on-select="false"
              :show-labels="true"
              :allow-empty="true"
              selectLabel="Սեղմեք ընտրելու համար"
              deselectLabel="Սեղմեք հեռացնելու համար"
              selectedLabel="Ընտրված է"
              placeholder="Երաշխիք"
            />
          </div>
          <template v-if="this.filters.type && (this.filters.type.value === 'competitive' || this.filters.type.value === 'one_person')">
            <div class="col-lg-3 mb-2">
              <multiselect
                class="mySelect"
                v-model="filters.competitiveProductCategories"
                :options="filters.competitiveProductCategoriesOptions"
                label="name"
                track-by="id"
                :searchable="true"
                :close-on-select="false"
                :show-labels="true"
                :allow-empty="true"
                selectLabel="Սեղմեք ընտրելու համար"
                deselectLabel="Սեղմեք հեռացնելու համար"
                selectedLabel="Ընտրված է"
                :multiple="true"
                placeholder="Ապրանք"
              />
            </div>
            <div class="col-lg-3 mb-2">
              <multiselect
                class="mySelect"
                v-model="filters.competitiveServiceCategories"
                :options="filters.competitiveServiceCategoriesOptions"
                label="name"
                track-by="id"
                :searchable="true"
                :close-on-select="false"
                :multiple="true"
                :show-labels="true"
                :allow-empty="true"
                selectLabel="Սեղմեք ընտրելու համար"
                deselectLabel="Սեղմեք հեռացնելու համար"
                selectedLabel="Ընտրված է"
                placeholder="Ծառայություն"
              />
            </div>
            <div class="col-lg-3 mb-2">
              <multiselect
                class="mySelect"
                v-model="filters.competitiveWorkCategories"
                :options="filters.competitiveWorkCategoriesOptions"
                label="name"
                track-by="id"
                :searchable="true"
                :close-on-select="false"
                :multiple="true"
                :show-labels="true"
                :allow-empty="true"
                selectLabel="Սեղմեք ընտրելու համար"
                deselectLabel="Սեղմեք հեռացնելու համար"
                selectedLabel="Ընտրված է"
                placeholder="Աշխատանք"
              />
            </div>
          </template>
          <template v-if="filters.type && filters.type.value === 'competitive'" >
            <div class="col-lg-3 mb-2">
              <multiselect
                class="mySelect"
                v-model="filters.isElectronic"
                :options="filters.isElectronicOptions"
                label="name"
                track-by="value"
                :searchable="false"
                :close-on-select="false"
                :show-labels="true"
                :allow-empty="true"
                selectLabel="Սեղմեք ընտրելու համար"
                deselectLabel="Սեղմեք հեռացնելու համար"
                selectedLabel="Ընտրված է"
                placeholder="Էլեկտրոնային / թղթային"
              />
            </div>
            <div class="col-lg-3 mb-2">
              <multiselect
                v-model="filters.procedure"
                :options="filters.procedureOptions"
                label="contact"
                track-by="id"
                :searchable="false"
                :close-on-select="false"
                :show-labels="true"
                :allow-empty="true"
                selectLabel="Սեղմեք ընտրելու համար"
                deselectLabel="Սեղմեք հեռացնելու համար"
                selectedLabel="Ընտրված է"
                :multiple="true"
                placeholder="Ընթացակարգի տեսակ"
              />
            </div>
          </template>
          <div class="col-lg-3 mb-2">
            <button @click="search" type="button" class="col-12 btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
              <i class="fas fa-search mr-2"></i>
              Որոնել
            </button>
          </div>
        </div>
      </div>
      <!-- Tab panes -->
      <div class="row">
        <div v-show="!loaded" class="col-12" style="height: 85px; padding: 20px">
          <div class="col-12 pt-5 position-relative">
             <div style="left: 0; right: 0; top: 0; bottom: 0;" class="text-big spinner-border spinner-border-lg m-auto position-absolute" role="status"></div>
          </div>
        </div>
        <div class="col-12 tenders-list">
          <div id="card" v-show="loaded">
            <v-server-table :url="tableDataUrl" :columns="columns" :options="options" @filter="listenTo" @loading ="onLoading" @loaded="onLoaded" ref="table">
                <template v-slot:viewed="{row}">
                  <div class="row">
                    <div class="col-6 row align-items-center">
                      <div v-if="!row.viewed" class="not-viewed-cicrcle"></div>
                    </div>
                    <div class="col-8" v-tooltip="'Առնչվող հայտարարություններ'">
                      <div v-tooltip="'Առնչվող հայտարարություններ'">
                        <button @click="() => $modal.show('tender-announcements-modal', {...row, handleGoToAnnouncement})" class="btn includer" style="background-color:transparent">
                            <i class="fa fa-link" aria-hidden="true"></i>
                            <span v-if="announcementsCount(row)" class="badge badge-primary">{{announcementsCount(row)}}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:tender_type="{row}">
                  {{row.type === 3 ? 'Պետական' : 'Մասնավոր'}}
                </template>
                <div slot="opening_finish_date" slot-scope="{row}" class="">
                  {{$moment(new Date(row.opening_date)).format('DD-MM-YYYY')}} - <br/><span class="text-primary font-weight-bold">{{$moment(new Date(row.finish_date)).format('DD-MM-YYYY HH:mm')}}</span>
                </div>
                <div slot="application" slot-scope="{row}" class="d-flex justify-content-center">
                  <template v-if="row.is_competition">
                      <template v-if="row.kind === 'competitive'">
                        <template v-if="me.package === 'Գոլդ' || me.package === 'Պրեմիում'">
                          <template v-if="!isNotNewProcedure(row)">
                            <button type="button" @click.stop="() => {$modal.show('application-modal', {...row, addToFavorite});setTenderViewed(row.id)}" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                              Մրցույթի հայտ
                            </button>
                          </template>
                        </template>
                        <template v-else>
                          <div v-tooltip="'Մրցույթի հայտ պատրաստելու գործիքը հասանելի է միայն Գոլդ կամ Պրեմիում փաթեթ ունեցող օգտատերերին'">
                            <button disabled type="button" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                              Մրցույթի հայտ
                            </button>
                          </div>
                        </template>
                      </template>
                    <div>
                      <button v-if="row.kind === 'one_person' && new Date(row.finish_date) > dateNow && row.is_mine === false" type="button" @click.stop="() => {$modal.show('suggestion-modal', {...row, resetComponent});setTenderViewed(row.id)}" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                        Գնային առաջարկ 
                      </button>
                      <div v-else></div>
                    </div>
                  </template>
                </div>
                <div slot="products" slot-scope="{row}" class="row justify-content-center">
                  <div class="col-12">
                      <span
                        :key="lot.toString() + lotIndex"
                        v-for="(lot, lotIndex) in row.rows.slice(0, 3)">
                          {{lot.name}}<span v-if="lotIndex !== row.rows.length-1">,</span>
                      </span>
                  </div>
                  <div v-if="row.rows.length > 3" class="col-12">
                    <span @click.stop="()=>{$modal.show('tender-rows-modal', {...row});setTenderViewed(row.id)}" class="text-primary" style="cursor: pointer">
                        Տեսնել բոլորը
                    </span>
                  </div>
                </div>
                <div slot="price" slot-scope="{row}" class="row justify-content-center">
                  <template v-if="me.package === 'Գոլդ'">
                        <div class="col-12">
                            {{row.price}}
                        </div>
                        <div v-if="row.price_file" class="col-12">
                            <a download target="_blank" :href="row.price_file">
                                <button type="button" @click="() => setTenderViewed(row.id)" class="btn btn-primary waves-effect waves-light" data-toggle="modal" data-animation="bounce">
                                <i class="fa fa-download" />
                                </button>
                            </a>
                        </div>
                  </template>
                  <template v-else>
                    <template v-if="row.price || row.price_file">
                      <span v-tooltip="'Նախահաշվային գինը հասանելի է միայն Գոլդ փաթեթ ունեցող օգտատերերին'">
                        <i style="font-size: 24px"  class="fas fa-eye-slash"></i>
                      </span>
                    </template>
                  </template>
                </div>
                <div slot="invitation" slot-scope="{row}" class="d-flex justify-content-center" >
                  <a v-if="row.kind !== 'one_person'" download target="_blank" :href="invitationLinkFix(row.invitation_link)">
                    <template v-if="me.package !== 'Անվճար' || !row.is_closed" >
                      <button type="button" @click="() => setTenderViewed(row.id)" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                        <i class="fa fa-download mr-1" /> Բեռնել
                      </button>
                    </template>
                    <template v-else>
                      <div v-tooltip="'Մրցույթի հրավերը բեռնելու համար թարմացրեք ձեր փաթեթի տեսակը'">
                        <button disabled type="button" @click="() => setTenderViewed(row.id)" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                          <i class="fa fa-download mr-1" /> Բեռնել
                        </button>
                      </div>
                    </template>
                  </a>
                  <div v-if="row.kind === 'one_person' && new Date(row.finish_date) > dateNow">
                    <button v-if="row.organize.contract !== ''" type="button" @click.stop="$modal.show('contract-draft-modal', row)" class="btn btn-primary waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                      Պայմանագիր
                    </button>
                  </div>
                  <div v-else></div>
                  <div class="ml-1 row align-items-center" v-if="row.guaranteed">
                    <div class="col text-success">
                        <i style="font-size: 32px" class="fas fa-shield-alt"></i>
                    </div>
                  </div>
                </div>
                <div slot="type" slot-scope="{row}" class="d-flex justify-content-center">
                 {{row.type === "PAPER" ? 'Թղթային' : 'Էլեկտրոնային'}}
                </div>
                <div slot="favorite" slot-scope="{row}" class="d-flex justify-content-center">
                  <div v-if="row.is_competition" class="star" :class="row.is_favorite && 'active-star'" @click="() => {toggleStar(row.id);setTenderViewed(row.id)}">
                    <a slot="icon" class="fa fa-star fa-lg"></a>
                  </div>
                </div>
            </v-server-table>
          </div>
        </div>
        <!-- end col -->
      </div>
    </div>
    <application-modal from="tenders"/>
    <suggestion-modal />
    <submitted-documents-modal />
    <new-editor-modal />
    <tender-rows-modal />
    <guarantee-modal/>
    <contract-draft-modal />
    <tender-announcements-modal />
    <row-specification-modal/>
  </div>
</template>
<script>
  import axios from 'axios'
  import Multiselect from 'vue-multiselect'
  import ApplicationModal from './modals/ApplicationModal'
  import TenderRowsModal from './modals/TenderRowsModal'
  import ContractDraftModal from './modals/ContractDraftModal'
  import NewEditorModal from '@/views/fileManagment/application/NewEditorModal'
  import SuggestionModal from './modals/SuggestionModal'
  import GuaranteeModal from '@/components/landing/GuaranteeModal'
  import SubmittedDocumentsModal from './modals/SubmittedDocumentsModal'
  import TenderAnnouncementsModal from './modals/TenderAnnouncementsModal'
  import RowSpecificationModal from '@/components/modals/RowSpecificationModal'

    export default {
    components: { RowSpecificationModal, Multiselect, ApplicationModal, NewEditorModal, TenderRowsModal, ContractDraftModal, SuggestionModal, GuaranteeModal, SubmittedDocumentsModal, TenderAnnouncementsModal},
    data() {
      return {
        dateNow: new Date(),
        filtersT: true,
        tableKey: 0,
        loaded: false,
        firstLoad: true,
        tableDataUrl: `${process.env.VUE_APP_API_URL}tender`,
        columns: [
          'viewed',
          'password',
          'title',
          'organizator',
          'products',
          'opening_finish_date',
          'price',
          'region',
          'type',
          'application',
          'invitation',
          'favorite'
        ],
        options: {
          sortable: [],
          rowClassCallback: function(row) {
            if(!row.is_competition){
              return 'bg-light-grey'
            }
          },
          // hiddenColumns: ['price', 'invite'],
          columnsDropdown: true,
          component: this,
          hiddenColumns: ['region', 'type'],
          requestFunction(data) {
            const dispatch = this.dispatch
            if (this.cancelSource) {
              this.cancelSource.cancel('Start new search, stop active search');
            }
            this.cancelSource = axios.CancelToken.source();
            return this.$client.get(this.url, {cancelToken: this.cancelSource.token, params: data})
            .catch(function (e) {
              dispatch('error', e)
            })
          },
          pagination: { chunk: 1 },
          customFilters: [
            'competition',
            'region',
            'status',
            'category',
            'type',
            'isElectronic',
            'procedure',
            'guaranteed',
            'organizator',
            'products',
            'services',
            'works',
            'tenderId',
            'tenderGroupId'
          ],
          filterByColumn: false,
          skin: 'table',
          headings: {
            viewed: '',
            password: 'Ծածկագիր',
            title: 'Անվանում',
            organizator: 'Պատվիրատու',
            products: 'Գնման առարկաներ',
            region: 'Տարածաշրջան',
            category: 'Խումբ / Կատեգորիա',
            type: 'Տիպ',
            opening_finish_date: 'Ժամկետը սկիզբ/ավարտ',
            price: 'Նախահաշվային գին',
            application: 'Դիմել',
            invitation: 'Մրցույթի հրավեր',
            favorite: 'Նախընտրել',
          },
          texts: {
            count:
            'Ցուցադրված է {from}֊ից {to}֊ը ընդհանուր {count} տողից|{count} տող|',
            first: 'Առաջին',
            last: 'Վերջին',
            filter: '',
            filterPlaceholder: 'Փնտրել',
            limit: '',
            page: 'Page:',
            noResults: 'Համընկնում չի գտնվել',
            noRequest: 'խնդրում ենք ընտրել առնվազն մեկ ֆիլտեր տվյալները ներբեռնելու համար',
            filterBy: 'փնտրել ըստ {column}',
            loading: 'Բեռնվում է...',
            defaultOption: 'ընտրել {column}',
            columns: 'Ընտրել դաշտերը',
          },
        },
        filters: {
          competition: { name: 'Մրցույթներ', value: true },
          competitionOptions: [
            { name: 'Բոլորը', value: null },
            { name: 'Մրցույթներ', value: true },
            { name: 'Հայտարարություններ', value: false },
          ],
          category: { name: 'Միայն իմ կատեգորիաները', value: 'onlyMy' },
          categoryOptions: [
            { name: 'Բոլորը', value: 'all' },
            { name: 'Միայն իմ կատեգորիաները', value: 'onlyMy' },
            // { name: 'Իմ նախընտրածները', value: 'applied' },
          ],
          status: { name: 'Ակտիվ մրցույթներ', value: 'active' },
          statusOptions: [
            { name: 'Բոլորը', value: 'all' },
            { name: 'Ակտիվ մրցույթներ', value: 'active' },
            { name: 'Ավարտված մրցույթներ', value: 'finished' },
          ],
          type: null,
          typeOptions: [
            { name: 'Պետական մրցակցային մրցույթներ', value: 'competitive' },
            { name: 'Պետական մեկ անձի մրցույթներ', value: 'one_person' },
            { name: 'Մասնավոր մրցույթներ', value: 'private' },
            { name: 'ՀՀ֊ից դուրս մրցույթներ', value: 'international' },
          ],
          isElectronic: null,
          isElectronicOptions: [
            { name: 'Թղթային', value: false },
            { name: 'Էլեկտրոնային', value: true },
          ],
          procedure: null,
          procedureOptions: [
            { name: 'ԳՀ', value: 'GH' },
            { name: 'ԲՄ', value: 'BM' },
            { name: 'ՀԲՄ', value: 'UBA' },
            { name: 'ՀՄԱ', value: 'HMA' },
          ],
          region: [],
          regionOptions: [],
          organizator: [],
          organizatorOptions: [],
          competitiveProductCategories: [],
          competitiveProductCategoriesOptions: [],
          competitiveServiceCategories: [],
          competitiveServiceCategoriesOptions: [],
          competitiveWorkCategories: [],
          competitiveWorkCategoriesOptions: [],
          privateProductCategories: [],
          privateProductCategoriesOptions: [],
          privateServiceCategories: [],
          privateServiceCategoriesOptions: [],
          privateWorkCategories: [],
          privateWorkCategoriesOptions: [],
          guaranteed: null,
          guaranteedOptions: [
            { name: 'Երաշխիքով', value: true },
            { name: 'Առանց երաշխիքի', value: false },
          ],
        }
      }
    },
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
      allTenders() {
        return this.$store.getters['organize/allOrganizes']
      }
    },
    async mounted(){
      const tenderId = this.$route.query.id
      const tenderGroupId = this.$route.query.tenderid
      if(tenderId){
        this.tenderId = tenderId;
        await this.$refs.table.setCustomFilters({
          tenderId: tenderId,
        });
        this.tableKey = this.tableKey + 1;
        // console.log(tenderId)
        // await this.$refs.table.setCustomFilters({
        //   tenderId: tenderId,
        // });
      } else if(tenderGroupId){
        this.tenderGroupId = tenderGroupId;
        setTimeout(async() => {
          await this.$refs.table.setCustomFilters({
            tenderGroupId: tenderGroupId,
          });
        }, 1000);
        // await this.$refs.table.setCustomFilters({
        //   tenderGroupId: tenderGroupId,
        // });
      } else {
        await this.$client.get('tender/filterOptions').then(({data}) => {
          this.filters.procedureOptions = data.procedure_types
          this.filters.regionOptions = data.regions
          this.filters.organizatorOptions = data.organizators
          this.filters.competitiveProductCategoriesOptions = data.competitive_product
          this.filters.competitiveServiceCategoriesOptions = data.competitive_service
          this.filters.competitiveWorkCategoriesOptions = data.competitive_work
          this.filters.privateProductCategoriesOptions = data.private_product
          this.filters.privateServiceCategoriesOptions = data.private_service
          this.filters.privateWorkCategoriesOptions = data.private_work
          if(data.columns){
            this.options.hiddenColumns = Object.entries(data.columns).filter(item => item[1] === 0).map(item => item[0])
          }
        })
        await this.handleMyFilters();
      }
      await setTimeout(() => {
        this.loaded = true;
        this.firstLoad = false;
      }, 1000);
    },
    methods: {
      invitationLinkFix(link){
        if(link.includes('https://gnumner.am')){
          return link.replace("https://gnumner.am/", "https://gnumner.minfin.am/");
        }
        return link;
      },
      isNotNewProcedure(row){
        switch (row.procedure.id) {
          case 8:
          case 9:
          case 10:
          case 11:
          case 12:
            return true
          default:
            return false
        }
      },
      async cancel() {
        this.$cancelSource.cancel("Optional message");
      },
      announcementsCount(row){
        const announcementsCount = row.announcements_count
        const tenderAnnouncementsCount = row.tender_state_id !== 0 ? row.tender_announcements_count : 0;
        return announcementsCount + tenderAnnouncementsCount
      },
      consoleLog(msg) {
        console.log(msg)
      },
      listenTo(a) {
        this.loaded = false;
      },
      onLoading(a) {
        this.loaded = false;
      },
      onLoaded(a) {
        if(!this.firstLoad){
          this.loaded = true;
        }
      },
      resetComponent(){
        this.$refs.table.refresh();
      },
      async handleGoToAnnouncement(announcementId){
        await this.$refs.table.setCustomFilters({
          tenderId: announcementId,
        });
        await this.$modal.hide('tender-announcements-modal')
      },
      async handleMyFilters(){
        if(this.filters.category.value === "onlyMy"){
          await this.$client.get('user-filters').then(async ({data: {data}}) => {
            if(data){
              // this.filters.status = data.status;
              this.filters.type = data.type;
              this.filters.region = data.region;
              this.filters.procedure = data.procedure;
              this.filters.organizator = data.organizator;
              this.filters.isElectronic = data.isElectronic;
              this.filters.guaranteed = data.guaranteed;
            }
            await this.search()
          })
        }
      },
      setTenderViewed(tenderId){
        this.$client.post('user-tenders', {
          tender_state_id: tenderId,
          applyed: false,
          viewed: true,
        }).then(() => {
          const currTender = this.$refs.table.data.find(tender => tender.id === tenderId)
          currTender.viewed = true
          // this.$refs.table.getData();
        })
      },
      async search() {
        // this.loaded = false;
        this.$router.replace({'query': null});
        this.$refs.table.customQueries.tenderId = null;
        this.$refs.table.customQueries.tenderGroupId = null;
        if(this.filters.competition){
          this.$refs.table.customQueries.competition = this.filters.competition.value;
        }
        if(this.filters.category){
          this.$refs.table.customQueries.category = this.filters.category.value;
        }
        if(this.filters.status){
          this.$refs.table.customQueries.status = this.filters.status.value;
        }
        if(this.filters.guaranteed){
          this.$refs.table.customQueries.guaranteed = this.filters.guaranteed.value ? 1 : 0;
        }
        if(this.filters.type){
          this.$refs.table.customQueries.type = this.filters.type.value;
          if(this.filters.type.value === 'competitive' || this.filters.type.value === 'one_person'){
            if(this.filters.isElectronic){
              this.$refs.table.customQueries.isElectronic = this.filters.isElectronic.value;
            }
            if(this.filters.procedure){
              this.$refs.table.customQueries.procedure = this.filters.procedure.map(item => item.id);
            }
            this.$refs.table.customQueries.products = this.filters.competitiveProductCategories.map(item => item.id);
            this.$refs.table.customQueries.services = this.filters.competitiveServiceCategories.map(item => item.id);
            this.$refs.table.customQueries.works = this.filters.competitiveWorkCategories.map(item => item.id);
          } else if(this.filters.type.value === 'private'){
            this.$refs.table.customQueries.products = this.filters.privateProductCategories.map(item => item.id);
            this.$refs.table.customQueries.services = this.filters.privateServiceCategories.map(item => item.id);
            this.$refs.table.customQueries.works = this.filters.privateWorkCategories.map(item => item.id);
          }
        } else {
          this.$refs.table.customQueries.type = null;
        }
        this.$refs.table.customQueries.region = this.filters.region.map(item => item.id);
        this.$refs.table.customQueries.organizator = this.filters.organizator.map(item => item.id);
        await this.$refs.table.refresh();
        // await setTimeout(() => {
        //   this.loaded = true;
        // }, 1000);
      },
      addToFavorite(tenderStateId){
        const currTender = this.$refs.table.data.find(tender => tender.id === tenderStateId)
        if(!currTender.is_favorite){
          currTender.is_favorite = true;
          this.$client.post('/tender/favorite', {tender_state_id: tenderStateId})
        }
      },
      toggleStar(tenderStateId){
        this.$client.post('/tender/favorite', {tender_state_id: tenderStateId})
        const currTender = this.$refs.table.data.find(tender => tender.id === tenderStateId)
        currTender.is_favorite = !currTender.is_favorite
      },
      showFilters(){
        this.filtersT = !this.filtersT
      }
    },
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .date-bloc span {
    font-size: 12px;
  }
  .mySelect .multiselect__tags{
    color: #1e7bb7;
    background-color: #1e7bb7;
  }
</style>
<style>
  .btn .badge {
    top: -7px;
  }
  legend{
    width: auto;
    margin: 0 10px;
    font-size: 14px;
  }
  fieldset{
    border-top: 1px solid #b3b3b3;;
    border-bottom: 1px solid #b3b3b3;;
  }
  .bg-light-grey{
    background-color: #e1e1e1;
  }
  .star{
    cursor: pointer;
  }
  .active-star{
    color: rgb(255, 165, 0);
  }
  .tenders-list th, .tenders-list td{
    max-width: 550px;
  }
  .not-viewed-cicrcle{
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #207db4;
  }
  .size{
    font-size: 25px;
    cursor: pointer;
  }
</style>